import { WizardModel } from '../models/wizard/wizard.model';
import { WizardStylingModel } from '../models/wizard/wizard-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';

export const /** @type {?} */ WizardTemplates = {
  defaultTemplate: {
    property: new WizardModel({
      display: true,
      disable: false,
      activeStepIndex: 0,
      showStepNumberAsIcon: true,
      showStepNumberAsPrefix: false,
      indexBefore: true,
      backButton: new ButtonModel({ label: 'Back' }),
      nextButton: new ButtonModel({ label: 'Next' }),
      finishButton: new ButtonModel({ label: 'Finish' }),
      headerPosition: 'above',
      footerPosition: 'below'
    }),
    style: new WizardStylingModel()
  }
}
